import { MatSelectChange } from '@angular/material/select';
import { Component, OnInit } from '@angular/core';
import { Report } from './reports.model';
import { ReportsService } from './reports.service';
import { REPORT_TYPES, LOGIN_COUNT_SOURCE, SELECT_START_END_DATE_ERROR, END_YEAR_GREATER_THAN_START_YEAR_ERROR, NO_REPORTS_FOUND } from '@root/app.constant';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../shared/auth.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  providers: [ReportsService],
})
export class ReportsComponent implements OnInit {
  constructor(
    public reportsService: ReportsService,
    private toastr: ToastrService
  ) {}

  reportsList: Report[] = [...REPORT_TYPES];

  startDate: Date = new Date();

  endDate: Date = new Date();

  selectedReportType: string;

  selectedStartYear: number;

  selectedEndYear: number;

  yearList = [];

  selectedSource: string;

  sourceList = LOGIN_COUNT_SOURCE;

  queryParm: string;

  today = new Date();
  public userInfo: any;

  ngOnInit() {
    this.selectedReportType = this.reportsList[0].type;
    this.userInfo = AuthService.userInfo();
    if(this.userInfo.isAdmin || this.userInfo.isSuperAdmin){
      this.reportsList.forEach(report => {
        if(report.type === "AUDIT_REPORT" || report.type === 'USER_SESSION_REPORT'){
            report.disabled = false;
        }
      });

      this.reportsList.sort(function(a, b){
        if(a.name < b.name) { return -1; }
        if(a.name > b.name) { return 1; }
        return 0;
      })
    }
  }
  public onReportChange(change: MatSelectChange) {
    if (change.value === 'UNIQUE_LOGIN_COUNT_REPORT') {
      const year = new Date().getFullYear();
      for (let i = 0; i < 50; i++) {
        this.yearList.push({
          label: year - i,
        });
      }
      this.selectedStartYear = this.yearList[0].label;
      this.selectedEndYear = this.yearList[0].label;

      this.selectedSource = this.sourceList[0].value;
    }
  }

  public downloadReports() {
    const sectedReport = this.reportsList.find(
      (r) => r.type === this.selectedReportType
    );
    if(this.startDate === null && this.endDate === null){
      this.toastr.error(SELECT_START_END_DATE_ERROR);
    }else{
      const startDate = moment(this.startDate).format('DD-MM-YYYY');
      const endDate = moment(this.endDate).format('DD-MM-YYYY');
      this.queryParm = `from-date=${startDate}&to-date=${endDate}`;
      if (this.selectedReportType === 'UNIQUE_LOGIN_COUNT_REPORT') {
        if (+this.selectedStartYear > +this.selectedEndYear) {
          this.toastr.error(END_YEAR_GREATER_THAN_START_YEAR_ERROR);
          return;
        }
        const startYear = this.selectedStartYear;
        const endYear = this.selectedEndYear;
        const source = this.selectedSource;
        this.queryParm = `from-date=${startYear}&to-date=${endYear}&source=${source}`;
      }
      this.reportsService
        .downloadReports(this.selectedReportType, this.queryParm)
        .subscribe(
          (response) => {
            saveAs(
              new Blob([response], { type: 'application/xls' }),
              `${sectedReport.name}.xls`
            );
            this.resetDate();
          },
          (error) => {
            if (error.errorMessage) {
              this.toastr.error(error.errorMessage);
            } else {
              this.toastr.error(NO_REPORTS_FOUND);
            }
          }
        );
    }
  }

  public resetDate(){
    this.startDate = null;
    this.endDate = null;
  }
}
